import axios from "axios";
import { NAVBAR_API } from "shared/constants";

export const fetchPaths = () => {
  return axios.get(String(NAVBAR_API));
};
